import { render, staticRenderFns } from "./Withdrawal.vue?vue&type=template&id=2e5b1b7c&scoped=true&"
import script from "./Withdrawal.vue?vue&type=script&lang=ts&"
export * from "./Withdrawal.vue?vue&type=script&lang=ts&"
import style0 from "./Withdrawal.vue?vue&type=style&index=0&id=2e5b1b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5b1b7c",
  null
  
)

export default component.exports